






















import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  setup(props, ctx) {
    const router = ctx.root.$router
    function openMediaLibrary() {
      router.push({ name: 'medias' })
    }

    return {
      openMediaLibrary,
    }
  },
})
